import React from 'react';
import {
    Mail
} from 'lucide-react';
import { Img } from 'components';
import Text from '../components/Text';
import { Feature } from '../components/feature';
import LandingPageComponentWrapper from '../components/LandingPageComponentWrapper';
import Button from '../components/Button';
import ContactUsForm from './ContactUsForm';
import Input from '../components/Input';
interface NewHeroSectionProps {
    renderComponents?: any[];
    sectionRefs?: React.MutableRefObject<any[]>;
}

export default function ContactUs({ renderComponents, sectionRefs }: NewHeroSectionProps) {

    return (
        <>
            <div className="relative mx-auto">
                <LandingPageComponentWrapper>
                    <Feature
                        mainClasses='bg-[#FCFAFF] md:p-2'
                        badge={"Contact Us"}
                        title={"Contact Us"}
                        description={
                            <div className='space-y-8'>
                                <div className='flex flex-col gap-2'>
                                    <Text label={"Need Help or want to explore SOOMUCH.AI?"} />
                                    <Text label={"Drop us a message and our team will be in touch within 24-48 Hours."} />
                                </div>
                                <div className='flex gap-2 items-center md:justify-center'>
                                    <Mail className='inline-block w-7 h-7 text-[black]' />
                                    <Text label={"support@soomuch.ai"} cName='text-lg font-semibold text-[black]' />
                                </div>

                            </div>
                        }
                        cta={
                            <div className="flex flex-col mt-40 gap-2">
                                <h2 className="text-sm font-medium text-[#4C4C4C] md:text-lg" style={{ fontFamily: 'Instrument Sans, sans-serif' }}>
                                    BACKED BY & PARTNERED WITH GLOBAL LEADERS
                                </h2>
                                <Img
                                    alt={"asdsdasd"}
                                    src={`images/new-landing-page/patnersLogo.png`}
                                    className="object-cover w-full"
                                />
                            </div>
                        }
                        rightSideElement={<ContactUsForm />}
                    />
                </LandingPageComponentWrapper>
                <LandingPageComponentWrapper bg={"bg-[#ECECF7]"}>
                    <Feature
                        mainClasses='bg-[#ECECF7] my-0'
                        title={"Ready to Transform your Institution?"}
                        description={"Discover how SOOMUCH.AI helps your institution grow faster and stand out."}
                        imageAlt="Discover"
                        imageQuery="images/new-landing-page/groupAvatars.png"
                        imgClassNames='w-full'
                        cta={
                            <>
                                <div className="w-[70%] md:w-full">
                                    <Input name='Email Address' />
                                </div>
                                <div className="mt-2 flex items-center gap-6 md:flex-col md:justify-center md:mt-6 sm:mt-4 sm:gap-4">
                                    <Button label='Get My Relationship Manager' type='gradient' />
                                    <Button label="Explore our Ecosystem" type='outlined' />
                                </div>
                            </>
                        }
                    />
                </LandingPageComponentWrapper>
            </div>
        </>
    );
}